import { useDispatch, useSelector } from 'react-redux';
import { ZfToast } from '@zafire/react';
import { AppDispatch } from '../../store';
import { hideToast, selectActiveToast } from '../../reducers/toastReducer';

export const AppToast = () => {
  const dispatch = useDispatch<AppDispatch>();
  const activeToast = useSelector(selectActiveToast);

  if (!activeToast) {
    return null;
  }

  return (
    <ZfToast
      show={true}
      type={activeToast.type}
      position={activeToast.position}
      titleText={activeToast.titleText}
      description={activeToast.description}
      dismissible={activeToast.dismissible}
      autoDismissDuration={activeToast.autoDismissDuration}
      onToastDismiss={() => dispatch(hideToast())}
    />
  );
};
